import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { isNullOrUndefined } from 'util';
@Injectable({
  providedIn: 'root'
})
export class PedidoService {
  headersPedidosDelDia = [
    { field: 'colaborador', header: 'Colaborador' },
    { field: 'menu', header: 'Plato' },
    { field: 'comentario', header: 'Comentario' }
  ];
  headersPagarPedidos = [
    { field: 'fecha', header: 'Fecha' },
    { field: 'descripcion', header: 'Plato' },
    { field: 'precio', header: 'Precio' },
  ]

  constructor(private httpService: HttpService) { }

  getHeadersPedidosDelDia() {
    return this.headersPedidosDelDia;
  }
  getHeadersPagarPedidos(){
    return this.headersPagarPedidos;
  }

  realizarPedido(pedido) {
    return this.httpService.post('pedido', pedido);
  }

  getPedidosByUser(id) {
    return this.httpService.get('pedido/user/' + id);
  }
  getPedidoDelDia() {
    return this.httpService.get('pedido/user/dia');
  }

  getPedidosPorDia(fecha: Date = null) {
    if (isNullOrUndefined(fecha)){
      fecha = new Date();
    }
    let horaFormateada = this.formatDate(fecha);
    return this.httpService.get('pedido/dia?fecha=' + horaFormateada);
  }

  updatePedido(pedido) {
    return this.httpService.put('pedido/' + pedido.id, pedido);
  }

  formatDate(fecha: Date) {
    let mes = fecha.getMonth();
    mes++;
    let rta = mes.toString() + '/' + fecha.getDate().toString() + '/' + fecha.getFullYear().toString();
    return rta;
  }
  deletePedido(pedido){
    return this.httpService.delete('pedido/'+pedido.id);
  }
}
